<div class="card card-primary card-outline style">
  <div class="card-body box-profile">
    
   
 <p class="style1">
      <b>{{number}}</b>
    </p>
    <div class="table-responsive">

      <div *ngFor="let c of output">
      <table class="table style">
      <tbody>
      <tr>
      <th style="width:30%">Receipt Type:</th>
      <td>{{c.receipt_type}}</td>
      </tr>

      <tr>
      <th>Customer Name:</th>
      <td>{{c.company_name}}</td>
      </tr>

      <tr>
      <th>Total Receipt Value:</th>
      <td>{{receipt_value}}</td>
      </tr>

      <tr>
      <th>Date And Time:</th>
      <td>{{DateAndTime}}</td>
      </tr>

      <tr>
      <th>Total Amount:</th>
      <td>{{c.total_amount}}</td>
      </tr>

      <tr>
      <th>Cheque Number:</th>
      <td>{{c.cheque_number}}</td>
      </tr>

      <tr>
      <th>Clearing Date:</th>
      <td>{{ClearingDate}}</td>
      </tr>

      <tr>
      <th>Company Code:</th>
      <td>{{c.company_code}}</td>
      </tr>

      <tr>
      <th>Responsible Employee Name:</th>
      <td>{{c.responsible_employee_name}}</td>
      </tr>

      <tr>
      <th>Transaction Type:</th>
      <td>{{c.transaction_type}}</td>
      </tr>

      <tr>
      <th>Status:</th>
      <td>{{c.status}}</td>
      </tr>

      <tr>
      <th>Entity:</th>
      <td>{{c.entity}}</td>
      </tr>


      </tbody></table>

      <p class="style2">
        <b>Sales:</b>
         <div class="card">
          <div class="space" *ngFor="let d of c.invoices">
          <div (click)='InvoiceDetails();getValue(d.invoice_id)'>
            <strong class="distance1">Invoice Number:</strong>{{d.invoice_number}}<br>
            <strong class="distance2">Transaction Type:</strong>{{d.transaction_type}}<br>
            <strong class="distance3">Payment Amount:</strong>{{d.payment_amount}}
          </div>
            <hr>

        
<!---------------------------------------
<form class="center">
<h1>Receipt Details</h1>
    <div class="settings" *ngFor="let c of output">

      <label>Number:</label><label>{{c.receipt_number}}</label>
      <label>Receipt Type:</label><label>{{c.receipt_type}}</label>
      <label>Customer Name:</label><label>{{c.company_name}}</label>
      <label>Total Receipt Value:</label><label>{{receipt_value}}</label>
      <label>Date and Time:</label><label>{{DateAndTime}}</label>
      <label>Total Amount:</label><label>{{c.total_amount}}</label>
      <label>Cheque No:</label><label>{{c.cheque_number}}</label>
      <label>Clearing Date:</label><label>{{c.clearing_date}}</label>
      <label>Company Code:</label><label>{{c.company_code}}</label>
      <label>Responsible Employee Name:</label><label>{{c.responsible_employee_name}}</label>
      <label>Transaction Type:</label><label>{{c.transaction_type}}</label>
      <label>Status:</label><label>{{c.status}}</label>
      <label>Entity:</label><label>{{c.entity}}</label>
    </div>
    
    </form>
      
      <div *ngFor="let c of output">
        <label class="colour">Sales</label><br>
        <ul *ngFor="let d of c.invoices" class="nobull" >
          <li (click)='InvoiceDetails();getValue(d.invoice_id)'><b>{{d.invoice_number}}</b></li>
          <li class="nobull">{{d.transaction_type}}</li>
          <li class="nobull">{{d.payment_amount}}</li> <br>
        </ul>
        
        </div>
   
 -------------------------------->    

  

